<div class="row mx-0">
    <div class="col-1 pl-0">
        <span class="material-icons-outlined">
            error_outline
        </span>
    </div>
    <div class="col-9 px-0 pl-1 sg-error-snackbar-message">
        <p class="mb-0">{{snackbarMessage}}</p>
        <!-- <p class="mb-0">Please try again.</p> -->
    </div>
    <div class="col-2 px-0">
        <button mat-button type="button"  (click)="dismiss()" class="px-1" style="float: right;">DISMISS</button>
    </div>
</div>